




import { Component } from 'vue-property-decorator'

/* eslint-disable-next-line */
/* @ts-ignore:next-line */
import * as tsParticles from '@/utils/plugins/tsparticles.engine'
// mixins
import DetectSafariMixin from '@/mixins/DetectSafariMixin'

@Component
export default class FireworksStatsAnimation extends DetectSafariMixin {
  private animation: any = null

  private mounted() {
    this.particlesInit()
  }

  private async particlesInit() {
    await tsParticles.loadFull(tsParticles.tsParticles)

    const options: any = {
      interactivity: {
        detectOn: 'canvas',
        events: {
          onHover: {
            enable: false, // Отключаем взаимодействие при наведении
          },
          onClick: {
            enable: true,
            mode: 'push', // При клике добавляем частицы
          },
          resize: true,
        },
        modes: {
          push: {
            quantity: this.isOSMobile ? 30 : 100, // Количество частиц при клике
          },
        },
      },
      fullScreen: {
        zIndex: 500,
      },
      particles: {
        color: {
          value: ['#B495FF', '#82B1FF', '#56C0AD', '#E14B84', '#ffa552', '#f44336'],
        },
        life: {
          duration: {
            sync: true,
            value: 5,
          },
          count: 1,
        },
        links: {
          enable: false,
        },
        move: {
          decay: 0.1,
          direction: 'none',
          enable: true,
          outModes: {
            default: 'destroy',
            top: 'out',
          },
          speed: {
            max: this.isOSMobile ? 20 : 40,
            min: this.isOSMobile ? 10 : 20,
          },
          straight: false,
        },
        number: {
          value: 0,
        },
        opacity: {
          animation: {
            enable: true,
            speed: 2,
            startValue: 'max',
            destroy: 'min',
          },
          value: {
            max: 1,
            min: 0,
          },
        },
        shape: {
          type: ['circle', 'square'],
          options: {},
        },
        size: {
          value: {
            max: this.isOSMobile ? 4 : 8,
            min: this.isOSMobile ? 1 : 2,
          },
        },
        tilt: {
          direction: 'random',
          enable: true,
          move: true,
          value: {
            min: 0,
            max: 360,
          },
          animation: {
            enable: true,
            speed: 60,
          },
        },
        wobble: {
          distance: 30,
          enable: true,
          move: true,
          speed: {
            min: -15,
            max: 15,
          },
        },
      },
      retina_detect: true,
    }

    this.animation = await tsParticles.tsParticles.load({
      id: 'tsparticles-stats',
      options,
    })
  }
}
